import WithConfigurations from "./WithConfigurations";

export default WithConfigurations;
